import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  atmReminderContainer: {
    margin: theme.spacing(1, 0)
  },
  atmReminderAlertButton: {
    whiteSpace: 'nowrap'
  }
}));
